import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-[#0a0e1a]" data-id="element-67">
      {/* Background Grid/Circuit Effect */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#00d4ff 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-68" />

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-[#00d4ff] opacity-10 blur-[120px] pointer-events-none" data-id="element-69" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-10 w-full max-w-2xl" data-id="element-71">
          <div className="relative rounded-2xl overflow-hidden border border-[#00d4ff]/30 box-glow-cyan" data-id="element-72">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-transparent to-transparent z-10" data-id="element-73" />
            <img src="https://cdn.magicpatterns.com/uploads/gnHR5NkwKwXZ88MRpxbund/heylloyd-image-1772650903129.png" alt="Potencia 21 - El Protocolo de Vigor Masculino" className="w-full h-auto object-cover" data-id="element-74" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-75">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white uppercase tracking-tight leading-tight mb-4" data-id="element-76">
            Recupera el vigor y la firmeza de tus 20s en solo{' '}
            <span className="text-[#00d4ff] text-glow-cyan" data-id="element-77">21 días</span>
          </h1>
          <p className="text-[#00d4ff] font-bold tracking-widest uppercase mb-8 text-lg md:text-xl" data-id="element-78">
            (Sin Fármacos)
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-12" data-id="element-79">
          El protocolo biológico para hombres de 40+ que quieren eliminar la
          fatiga, triplicar su energía y reactivar su deseo natural dominando su
          cortisol.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="w-full max-w-md" data-id="element-80">
          <CTAButton className="w-full" onClick={() => {
          document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-81">
            ¡Quiero recuperar mi vigor ahora!
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}